import React from 'react'
import { Col, Grid, Image, Row } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import injectStyles from 'react-jss'
import EditIcon from '@material-ui/icons/Edit'
import { AmbassadorSection } from 'Components/City/Page/Ambassador/AmbassadorSection'
import { SectionTitle } from 'Components/Section/SectionTitle'
import * as CONST from '../../../../../../Reducers/Ambassador/const'
import StyledIconButton from '../../../../../../Components/Form/StyledIconButton'
import { authorization } from '../../../../../../Module/Auth/Auth'
import useGraphQLFetch from '../../../../../../Utils/Hooks/useGraphQLFetch'
import { getBrandAmbassadorsVerificationEmail } from '../../gql'
import SubmitButton from 'Components/Form/SubmitButton'

const styles = {
  button: {
    marginTop: '10px',
  },
}

const businessNumberTitle = country => {
  switch (country) {
    case 'FR':
      return 'SIRET'
    case 'UK':
      return 'UTR'
    case 'AU':
      return 'ABN'
    default:
      return 'Business Number'
  }
}

const ContactDetailsSection = ({
  ambassador,
  cities,
  ambassadorId,
  classes,
}) => {
  const history = useHistory()
  const showBlockedReason =
    [
      CONST.AMBASSADOR_STATUS_KEY.BLOCKED,
      CONST.AMBASSADOR_STATUS_KEY.TERMINATING,
    ].includes(ambassador.status) && ambassador.blockedReason

  let countryCode

  if (cities.length > 0) {
    let city = cities.find(cities => ambassador.city.id === cities.id)
    countryCode = city.country.countryCode
  }

  const { data, isLoaded } = useGraphQLFetch({
    fetchFn: getBrandAmbassadorsVerificationEmail,
    defaultFetchArgs: ambassadorId,
  })
  const getActiveStatusText = ({ status, isVerified }) => {
    const button = isLoaded ? (
      <div className={classes.button}>
        <SubmitButton
          hideSvg={true}
          value="Verify email"
          onClick={() =>
            window.open(data.brandAmbassador.emailVerificationLink)
          }
          id="verifyEmail"
        />
      </div>
    ) : null
    const activeStatusText =
      status === CONST.AMBASSADOR_STATUS_KEY.ACTIVE && isVerified ? 'Yes' : 'No'
    return (
      <div>
        <span>
          {activeStatusText} {isVerified ? '' : '. Email is not verified'}
        </span>
        {!isVerified && button}
      </div>
    )
  }

  const formattedbusinessNumber =
    ambassador.businessNumber &&
    ambassador.businessNumber.replace(/.(?=.{4,}$)/g, '*')

  return (
    <AmbassadorSection>
      <Grid fluid>
        <Row>
          <Col xs={12}>
            <SectionTitle>Contact Details</SectionTitle>
            {(authorization.isAdmin() || authorization.isCityManager()) && (
              <StyledIconButton
                style={{ float: 'right' }}
                onClick={() =>
                  history.push(history.location.pathname + '/edit')
                }
              >
                <EditIcon />
              </StyledIconButton>
            )}
          </Col>
        </Row>
        <Row>
          <Col xs={3}>
            <Image
              src={ambassador.profilePicture}
              className="profile-picture"
            />
          </Col>
          <Col xs={9}>
            <Row>
              {ambassador.email && (
                <Col xs={4} className="ambassador-details-col">
                  <p className="col-title">Email Address</p>
                  <p className="email">{ambassador.email}</p>
                </Col>
              )}
              {ambassador.mobilePhone && (
                <Col xs={4} className="ambassador-details-col">
                  <p className="col-title">Phone number</p>
                  <p>{ambassador.mobilePhone || '-'}</p>
                </Col>
              )}
              {countryCode !== 'US' && (
                <Col xs={4} className="ambassador-details-col">
                  <p className="col-title">
                    {businessNumberTitle(countryCode)}
                  </p>
                  <p>{formattedbusinessNumber || '-'}</p>
                </Col>
              )}
              {ambassador.city && (
                <Col xs={4} className="ambassador-details-col">
                  <p className="col-title">City</p>
                  <p>{ambassador.city.name || '-'}</p>
                </Col>
              )}
              {ambassador.status && (
                <Col xs={4} className="ambassador-details-col">
                  <p className="col-title">Status</p>
                  <p className="text-capitalize">
                    {CONST.AMBASSADOR_STATUS_LABEL[ambassador.status] || '-'}
                    {showBlockedReason && ` - ${ambassador.blockedReason}`}
                  </p>
                </Col>
              )}
              {ambassador.status && (
                <Col xs={4} className="ambassador-details-col">
                  <p className="col-title">Active</p>
                  <p className="text-capitalize">
                    {getActiveStatusText(ambassador)}
                  </p>
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      </Grid>
    </AmbassadorSection>
  )
}

export default injectStyles(styles)(ContactDetailsSection)



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Ambasador/Components/ContactDetailsSection/index.js